import { mapSettings } from '../util.js'

// GLOBAL
export function UPDATE_IS_LOADING(state) {
  state.isLoading = true
}

export function CLEAR_IS_LOADING(state) {
  state.isLoading = false
}

// SETTINGS
export function UPDATE_SETTINGS(state, data) {
  const settings = mapSettings(data)
  state.settings = settings
}

export function UPDATE_MENU(state, data) {
  state.settings.menu = data
}

export function UPDATE_CLIENT(state, data) {
  state.client = data
}

export function UPDATE_USER(state, data) {
  state.user = data
}

export function UPDATE_USER_ACCESS(state, data) {
  state.userAccess = data
}

export function CLEAR_USER(state) {
  state.user = null
}

export function CLEAR_USER_ACCESS(state) {
  state.userAccess = false
}

export function UPDATE_TEMPLATE_VIEW(state, data) {
  state.templateView = data
}

export function UPDATE_IDLE_TIMER_CLOSED(state, data) {
  state.idleTimerClosed = data
}

// POSTS
export function UPDATE_CURRENT_POST(state, data) {
  // ADD target="_blank" to all anchor tags.
  if (data.body) {
    const regEx = new RegExp('<a href', 'g')
    data.body = data.body.replace(regEx, '<a target="_blank" href')
  }

  state.currentPost = data
}

export function CLEAR_CURRENT_POST(state) {
  state.currentPost = {}
}

export function UPDATE_CURRENT_POST_RESOURCES(state, data) {
  state.currentPost.resources = data
}

export function CLEAR_CURRENT_POST_RESOURCES(state) {
  state.currentPost.resources = {}
}

export function UPDATE_CURRENT_POSTS_TEMPLATE_ID(state, data) {
  state.currentPostsTemplateId = data
}

export function UPDATE_POSTS_VIEW(state, data) {
  state.postsView = data
}

export function UPDATE_FILTER_POSTS_BY(state, data) {
  if (data.draft_reset) {
    state.filterPostsBy = {
      keywords: null,
      category: null,
      year: null,
      tag: null,
      industry: null,
      draft: 1,
      matchAll: false,
    }
  } else if (data.reset) {
    let current_category = state.filterPostsBy.category
    // Reset all search data
    state.filterPostsBy = {
      keywords: null,
      category: current_category,
      year: null,
      tag: null,
      industry: null,
      draft: null,
      matchAll: false,
    }
  }
  if (data.showAllPosts) {
    state.filterPostsBy.category = null
    // @todo test - need to also reset other filters?
  }

  if (data.hasOwnProperty('keywords')) {
    state.filterPostsBy.keywords = data.keywords
  }
  if (data.hasOwnProperty('category')) {
    state.filterPostsBy.category = data.category
  }
  if (data.hasOwnProperty('year')) {
    state.filterPostsBy.year = data.year
  }
  if (data.hasOwnProperty('tag')) {
    state.filterPostsBy.tag = data.tag
  }
  if (data.hasOwnProperty('industry')) {
    state.filterPostsBy.industry = data.industry
  }
  if (data.hasOwnProperty('draft')) {
    state.filterPostsBy.draft = data.draft
  }
  if (data.hasOwnProperty('matchAll')) {
    state.filterPostsBy.matchAll = data.matchAll
  }
}

// @todo not used???? remove getter and state and update components that seem to use it
export function UPDATE_FILTER_RESOURCE_BY(state, data) {
  if (data.reset) {
    // Reset all search data
    state.filterResourceBy = {
      keywords: null,
      type: null,
    }

    if (data.keywords) {
      state.filterResourceBy.keywords = data.keywords
    }
    if (data.type) {
      state.filterResourceBy.type = data.type
    }
  }
}
